import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { useAutomatedSurveyQueries } from "@/queries/automated-surveys/queryOptions";

import { AutomatedSurveysList, type AutomatedSurveysListProps } from "./AutomatedSurveysList";

const AUTOMATED_SURVEYS_LIMIT = 20;

export function ListAutomatedSurveysPage(): React.ReactNode {
  const automatedSurveyQueries = useAutomatedSurveyQueries();
  const [page, setPage] = useState<number>(0);

  const automatedSurveysQueryParams = {
    Offset: page * AUTOMATED_SURVEYS_LIMIT,
    Limit: AUTOMATED_SURVEYS_LIMIT,
  };

  const {
    data: automatedSurveys,
    isFetching: isFetchingAutomatedSurveys,
    error,
  } = useQuery(automatedSurveyQueries.list(automatedSurveysQueryParams));

  if (error) {
    return <ErrorPage error={error} />;
  }

  const totalPages = automatedSurveys ? Math.ceil(automatedSurveys.total / AUTOMATED_SURVEYS_LIMIT) : 0;

  const contentProps: AutomatedSurveysListProps = {
    automatedSurveys: automatedSurveys?.items ?? [],
    isLoading: isFetchingAutomatedSurveys,
    page,
    onPageChange: setPage,
    totalPages,
  };

  return <AutomatedSurveysList {...contentProps} />;
}
